<template>
  <v-fade-transition mode="out-in">
    <v-btn
      class="me-3 no-bg" icon :aria-label="$t('common.change_theme')"
      :key="isDark"
      @click="isDark = !isDark"
    >
      <v-icon>
        {{ isDark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
      </v-icon>
    </v-btn>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'
import useAppConfig from '@core/@app-config/useAppConfig'

export default {
  setup() {
    const { isDark } = useAppConfig()

    return {
      isDark,

      // Icons
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
    }
  },
}
</script>

<style lang="scss">

</style>
